// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"816":"c2b1b115","832":"ad24872a"}[chunkId] + ".chunk.js";
};